/* eslint-disable no-useless-escape */
/* eslint-disable no-control-regex */

import { Nil } from '../types'

/* eslint-disable max-len */
const EMAILRE =
  /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i

const DomainsToFix = {
  'gmail.com':
    /@(gmial\.com|gmali\.com|gmal\.com|gmil\.com|gmoil\.com|gamil\.com|gmail\w+\.com|gmailcom\.com)/i,
  'aol.com': /@(alo\.com|ao\.com|al\.com)/i,
  'yahoo.com': /@(yaho\.com|yahooo\.com|yaoo\.com)/i,
  'msn.com': /@(mn\.com|ms\.com|msm\.com)/i,
  'bellsouth.net': /@(bellsou.\.com|bellsou.\.net|bellsouthh\.net)/i,
  'telus.net': /@(tellus\.net)/i,
  'verizon.net': /@(verzon\.net|verizn\.net|vrizon\.net|verizno.net)/i,
  'vca.com': /@(vac.com)/i,
  'yandex.ru': /@(yandx.ru)/i,
}

const applyEmailDomainFix = (str: string | null) => {
  if (!str) {
    return str
  }

  const DomainsToFixEntries = Object.entries(DomainsToFix)

  for (let i = 0; i < DomainsToFixEntries.length; i++) {
    const [domain, regex] = DomainsToFixEntries[i]
    if (str.search(regex) !== -1) {
      return str.replace(regex, `@${domain}`)
    }
  }

  return str
}

const hasSuspiciousEmail = (str: string | null) => {
  if (str) {
    if (str.search(/@\w\.(com|edu|org|gov)/i) !== -1) {
      // Single letter domain is suspicious
      return true
    }
    if (str.search(/^(missing|need|blank|empty|noemail)(\.{1,2})?@/i) !== -1) {
      // looks like junk
      return true
    }
    if (
      str.search(
        /@(missing|need|blank|empty|noemail|bad|empty|none|unknown|declined)\./i,
      ) !== -1
    ) {
      // Suspicious domains
      return true
    }
  }
  return false
}

export const validateCommonEmailMistakes = (str: string | Nil) => {
  if (!str) {
    return { email: str, suspicious: false, fixed: false }
  }

  const match = str.match(EMAILRE)
  let email = match ? match[0] : null

  // See if we have a domain tweak we want to make
  email = applyEmailDomainFix(email)

  // If we got here, we have an email that passes validation. Let's see if it looks like a real email or not
  const suspicious = hasSuspiciousEmail(email)

  return { email, suspicious, fixed: email && str !== email }
}
